import { encode } from ".";
import { History, Location } from "history";

/**
 * Routes to the box view page with the given box ID and additional parameters.
 *
 * @param boxID - The ID of the box to view
 * @param location - The current location object from the history
 * @param history - The history object for navigation
 * @param params - Additional URL parameters as a string (optional)
 */
export const routeToBoxesView = (
  boxID: string,
  location: Location,
  history: History,
  params: string = "",
) => {
  const encodedId = encode(boxID) || "";

  const currentUrl = new URL(
    location.pathname + location.search,
    window.location.origin,
  );

  const newUrl = new URL(
    `/delivery-management/parcel-tracking/boxes/${encodedId}/view`,
    window.location.origin,
  );

  // to safely check incase 'from' already exists, we dont wanna
  // duplicate this param and route wrongly
  const fromParam = currentUrl.searchParams.get("from");
  if (fromParam) {
    newUrl.searchParams.append("from", fromParam);
  } else {
    newUrl.searchParams.append(
      "from",
      encodeURIComponent(currentUrl.pathname + currentUrl.search),
    );
  }

  if (params) {
    const additionalParams = new URLSearchParams(params);
    additionalParams.forEach((value, key) => {
      newUrl.searchParams.append(key, value);
    });
  }

  history.push(newUrl.pathname + newUrl.search);
};
